import * as Styled from '../../policy.styled';

function TermsOfServiceZh() {
  return (
    <Styled.MainWrapper>
      <h3>第1章 總則</h3>
      <p>第1條 目的</p>本條款旨在規範使用者（以下簡稱「您」）與 BubbleTap Corp.（以下簡稱「公司」）所提供之
      Tingle、獎勵等所有服務（以下簡稱「本服務」）相關之權利、義務及責任事項。
      <br />
      <br />
      使用者（參考第2條內的用語定義）使用本公司所提供的服務時，即視為您已同意並接受本服務條款與本公司所訂定的所有相關政策。
      <p>第2條 用語定義</p>
      <ol>
        ① 本條款中所使用的用語定義如下：
        <li>「使用者」 指使用本公司所提供服務的會員與非會員。</li>
        <li>「會員」 指同意本條款及提供個人資訊，並獲得服務使用資格的對象。</li>
        <li>
          「內容」 指與本公司所提供服務相關，已發佈、提供或生成的所有內容。這包括人工智慧（以下簡稱
          AI）製作或生成的角色、故事情節、故事背景、文件、文字、對話、照片、資訊、圖片、影片、語音備忘錄、音樂、設計、演算法、提示詞等（統稱為「素材」）。
        </li>
        <li>「輸入訊息」 指使用者為利用本公司的 Tingle 服務與素材而輸入的文字。</li>
        <li>「輸出訊息」 指 Tingle 服務基於使用者輸入的訊息所輸出的文字。</li>
        <li>「付費服務」 指本公司有償提供的內容及相關服務。</li>
        <li>
          「存取裝置」
          指個人電腦、手機、平板等，但不限於此，意指未來開發用於存取內容等資訊的任何形式之硬體、裝置等實體物品。
        </li>
        <li>
          「貼文」
          指會員使用服務時，在服務上發佈的符號、文字、圖片、語音、音訊、影像、影片等資訊形式的文字、圖片、照片、影片及各種檔案與連結等。此亦包括使用者為在本公司平台上製作或生成
          AI 內容而輸入的提示詞、介紹、說明、圖片、介紹詞等。
        </li>
        <li>
          「內部貨幣」
          指會員可於本公司提供的應用程式或平台內獲得、購買或收到的虛擬貨幣。內部貨幣是應用程式內可與本公司提供的付費服務交換的媒介。
        </li>
        ② 本條款中所使用的用語定義，除本條第1項各款所規定者外，遵照個別服務條款、服務指南、相關法令、其他一般商業慣例。
      </ol>
      <p>第3條 身分資訊等之提供</p>
      公司應將其個人資訊處理政策、公司名稱、代表人姓名、地址、電話號碼、電子郵件地址、營利事業統一編號、網路銷售業申報號碼、客服中心等資訊，公布於服務初始畫面，以利會員知悉。
      <p>第4條 條款的公布與修訂</p>
      <ol>
        ① 公司應將本條款內容公布於服務初始畫面或透過獨立連結頁面、彈出式視窗等方式呈現，以利會員知悉。
        <br />
        <br />②
        在不違反韓國《資訊通信網路利用促進及資訊保護法》等相關法律、《電子商務消費者保護》等相關法律、《條款規範》相關法律等相關法規的前提下，公司可修訂本條款。
        <br />
        <br />③
        公司修訂條款時，應於適用日期前7日至適用日期止，依第1項規定之方式，將適用日期及修訂事由與現行條款一併公告。但若修訂內容對會員不利，則應於適用日期前30日公告，並透過會員提供的電子郵件、服務內的彈出式視窗等電子方式另行明確通知會員。
        <br />
        <br />
        ④
        若公司依前項規定，明確公告或通知會員，表示若會員未在7日或30日內表示拒絕，則視為同意條款修訂，且會員未明確表示拒絕時，即視為會員已同意修訂後的條款。
        <br /> <br />⑤
        若會員不同意適用修訂後的條款，公司將無法適用該修訂條款，此時會員可終止使用合約。但若有特殊情況導致無法適用舊有條款時，公司則可終止使用合約。
      </ol>
      <p>第5條 條款的解釋</p>
      ①
      除了本條款之外，公司可制定獨立的使用條款及政策（以下簡稱「個別條款等」），若其內容與本條款相牴觸，則優先適用個別條款等。
      <br />
      <br />
      ② 本條款未盡事宜或解釋疑義，應依個別條款等、相關法令或商業慣例辦理。
      <br />
      <br />③ 關於公司取得著作權人等內容提供者授權，提供會員使用的付費服務，可能適用內容提供者國家的法律及條約。
      <p>第6條 服務使用合約等之簽訂</p>
      <ol>
        ①
        服務使用合約會在使用人使用本公司提供的服務時簽訂。此外，服務使用合約是由欲成為會員者（以下簡稱「申請人」）同意本條款內容後申請加入會員，並經本公司同意該申請後簽訂。
        <br /> <br />
        ②
        本公司原則上會同意用戶的申請。但若申請人未滿14歲，且未經法定代理人（如父母）同意；或因用戶的個人因素而無法通過審核；或非本人姓名或盜用他人名義；或喪失本公司會員資格；或違反本條款各項規定等，本公司將不予同意或於事後終止使用合約。
        <br /> <br />
        ③ 本公司在根據第1項規定申請時，得要求透過專業機構進行實名確認及實名驗證。
        <br /> <br />
        ④ 若公司在服務相關設備上沒有餘裕，或技術及業務上發生問題時，得暫緩同意申請。
        <br /> <br />
        ⑤ 當會員申請依據第2項和第4項規定不被同意或暫緩時，本公司原則上會通知申請人。
        <br /> <br />
        ⑥
        使用合約成立的時刻，訂為本公司在申請流程中顯示完成加入會員的時間；若是付費服務使用合約，則訂為在申請流程中顯示完成購買的時間。
        <br /> <br />
        ⑦ 根據本公司的政策，可能會將會員分等級，並在服務使用時間、次數、服務項目等方面設限。
        <br /> <br />
        ⑧
        為遵守韓國《青少年保護法》、韓國《電影及錄影帶振興法》等法令規定的等級與年齡，本公司可能會對會員進行使用限制或分級限制，並要求其進行實名驗證。
        <br /> <br />
        ⑨ 會員若要使用付費服務，必須同意本條款及該付費服務的個別條款等，並按照付費服務的使用條件支付費用。
        <br /> <br />
        ⑩
        如果未滿19歲的未成年會員欲使用付費服務，本公司會在簽約前告知，若未取得父母等法定代理人的同意或事後追認，未成年會員本人或其法定代理人可取消該合約。
        <br />
      </ol>
      <p>第7條 會員資料變更</p>
      <ol>
        ① 會員依本條款向公司提供資訊時，應提供真實資料；若因提供假資料而產生之任何不利後果，將不受公司保護。
        <br />
        <br />
        ② 會員在申請會員時所記載的事項如有變更，應透過線上方式修改，或以電子郵件或其他方式通知公司。
        <br />
        <br />
        ③ 因未依前項規定將變更事項通知公司而導致會員及其他第三人所遭受之任何不利後果，本公司概不負責。
        <br />
      </ol>
      <p>第8條 個人資料保護義務</p>
      本公司將依據《個人資料保護法》等相關法令的規定，努力保護會員的個人資料。關於個人資料的保護及使用，將適用相關法律及本公司的個人資料處理方針。然而，本公司的個人資料處理方針不適用於本公司官方網站以外所連結的網站。
      <p>第9條 會員帳號與密碼的管理義務</p>
      <ol>
        ① 會員應負責管理自己的帳號與密碼，不得將其提供給第三人使用。會員需對在其帳號下發生的一切活動負所有責任。
        <br />
        <br />
        ②
        若本公司判斷會員的帳號有個人資料外洩的疑慮，或有違社會善良風俗、或可能被誤認為是公司相關人員及服務營運者時，可直接限制該帳號的使用。
        <br />
        <br />
        ③ 會員發現帳號與密碼遭盜用或被第三人使用時，應立即通知本公司並遵循本公司的指示。
        <br />
        <br />④ 若會員未依第3項規定通知本公司，或雖已通知但未遵循本公司指示，導致發生任何不利後果，本公司概不負責。
        <br />
        <br />⑤ 若有可疑情況違反本服務條款或公司政策，本公司有權終止或限制會員的帳號。
      </ol>
      <p>第10條 對會員的通知</p>
      <ol>
        ①
        當本公司向會員發出通知時，除非本條款另有規定，否則可透過服務內的電子郵件地址、電子訊息、登入時的彈出視窗等方式進行。
        <br />
        <br />②
        若為對全體會員的通知，本公司可透過在服務內的佈告欄、彈出視窗等處公告7天以上，以取代前項的通知方式。但若涉及對會員本人交易有重大影響的事項，則仍會以前項的方式進行個別通知。
      </ol>
      <p>第11條 公司的義務</p>
      <ol>
        ① 本公司不會進行相關法律、本條款及個別條款等所禁止或違反善良風俗的行為，並將盡最大努力持續且穩定地提供服務。
        <br />
        <br />
        ② 本公司為確保會員能安全使用服務，應具備保護個人資料（包含信用資訊）的安全系統，並應公告及遵守個人資料處理方針。
        <br />
        <br />
        ③ 本公司應備妥必要的人力及系統，以便適當處理使用者在使用服務時產生的不滿或損害賠償請求。
        <br />
        <br />④
        本公司若認定會員所提出的意見或不滿屬合理情況，應進行處理。對於會員所提出的意見或不滿，本公司將透過佈告欄或電子郵件等方式，向會員告知處理過程及結果。
        <br />
        <br />⑤ 對於會員或使用者因其非法行為或本公司禁止之行為所造成的任何損害或損失，本公司概不負責。
      </ol>
      <p>第12條 會員的義務</p>
      <ol>
        ① 會員不得從事下列行為。
        <li>申請或變更時，輸入虛假內容</li>
        <li>盜用他人資訊</li>
        <li>修改、變更、翻譯或使用本公司發布的資訊</li>
        <li>發送或發布本公司規定資訊以外的資訊（例如電腦程式等）</li>
        <li>使用本公司服務所提供的提示詞、軟體或資料的原始碼</li>
        <li>規避或妨礙本公司服務的安全功能或使用限制</li>
        <li>未經授權存取、損壞、停用、妨礙、超載本公司或第三方的資料、系統或網路</li>
        <li>可能對本公司或第三方造成實質性損害、損傷或損失的行為</li>
        <li>侵害本公司與其他第三方的著作權等智慧財產權</li>
        <li>損害本公司及其他第三方的名譽或妨礙其業務的行為</li>
        <li>在服務中公開或發布淫穢或暴力的訊息、影像、語音或其他違反公序良俗的資訊</li>
        <li>未經本公司同意，以營利為目的使用服務的行為</li>
        <li>讓本人以外的第三方使用會員帳號的行為</li>
        <li>違反本公司及會員所屬國家法律的行為</li>
        <li>其他非法或不正當的行為</li>
        <br />②
        會員及使用者需對透過文字訊息、語音訊息、圖片、影片、素材等方式所生成的內容及發文負全部責任。會員及使用者需對使用本公司服務所產生的AI輸出內容負全部責任。會員及使用者同意在使用本公司的AI服務時，將遵守服務條款、公司政策及相關法律，並對因本公司禁止或非法的行為所產生的一切責任負責。
        <br />
        <br />③
        會員或使用者使用本公司的AI服務時，視為已認知該服務所產生的輸出文字、文件、圖片、影像、語音、音樂、設計等均為AI生成物。本公司不保證由本公司的AI服務所產生的結果、內容或素材的準確性或事實與否。
        <br />
        <br />④
        會員應遵守相關法律、本條款及營運規章、個別條款等規定、使用指南及服務相關公告的注意事項、本公司所通知的事項、《青少年保護法》等，且不得有妨礙本公司業務之行為。若會員或使用者未遵守上述規定，本公司可暫停或終止其帳號。帳號暫停或終止時，本公司可移除該會員或使用者的發文或內容。
      </ol>
      <p>第13條 付費服務的內容等標示</p>
      <ol>
        ① 本公司應在該付費服務的使用初始畫面或FAQ等處，以會員易於理解的方式標示以下事項。
        <li>付費服務的名稱</li>
        <li>付費服務主體的姓名（法人時為法人名稱）、地址、電話號碼</li>
        <li>付費服務的內容、使用方法、使用費用及其他使用條件</li>
        <br />
        ② 本公司付費服務可使用的設備及所需的最低技術規格，將依建議規格資訊為準。
        <br />
        <br />
        ③
        本公司在提供付費服務時，將提供有關付費服務的更換、退貨、保證以及其退款條件與程序的相關事項。請參閱服務條款第19條。
        <br />
        <br />④
        本公司提供的付費服務，如使用券或商品券等，可透過本公司以外的第三方（包括本公司的關係企業）進行銷售，該銷售商品的使用方式、取消及退款等，將依各合作夥伴所提供的付費服務使用條款及政策辦理。
      </ol>
      <p>第14條 服務的提供、中斷及變更</p>
      <ol>
        ① 本公司可將服務劃分為特定範圍，並為各範圍單獨指定可使用時間。但在此情況下，將會事先公告相關內容。
        <br />
        <br />
        ② 原則上，服務全年無休，每日24小時提供。
        <br />
        <br />
        ③
        當因電腦等資訊通訊設備的維護檢查、更換及故障、通訊中斷或營運上有重大事由時，本公司可暫時中斷服務的提供。在此情況下，本公司將依本條款規定的方式通知會員。但若有無法事先通知的不可抗力事由，則可在事後通知。
        <br />
        <br />
        ④ 本公司在需要時，可實施例行維護作業，維護時間將依服務提供畫面上公告的內容為準。
        <br />
        <br />
        ⑤
        若因業務項目的轉換、業務的放棄、分割或合併等原因導致無法繼續提供付費服務時，本公司將依本條款規定的方式通知會員，並依當初提出的條件向會員進行賠償。
        <br />
        <br />⑥
        若有重大事由，本公司可因營運或技術上的需求，變更所提供的全部或部分服務，並在該服務的初始畫面上公告相關事項。但若變更的是付費服務，且變更內容重大或對會員不利時，將依本條款規定的方式通知會員，並在必要時依本條款規定向會員進行賠償。
      </ol>
      <p>第15條 資訊提供及廣告刊登</p>
      <ol>
        ①
        公司可透過公告或電子郵件等方式，向會員提供其在使用服務時，認為有必要的多種資訊。但是，會員除了相關法律規定的交易相關資訊、顧客諮詢回覆等內容外，可隨時拒絕接收電子郵件等資訊。
        <br />
        <br />② 公司如欲透過電子傳輸媒介傳送第 1
        項所述的資訊，應事先徵得會員同意後再進行傳送。但是，與會員交易相關的資訊及顧客諮詢的回覆，無需事先同意即可傳送。
        <br />
        <br />③
        若使用者申請接收公司服務內容及為順暢使用服務所提供的更新通知，公司將會透過電子郵件、簡訊、應用程式推播、電子訊息等電子傳輸媒介向使用者提供資訊（以下簡稱「更新通知」）。
        <br />
        <br />④ 更新通知的內容可依據公司的服務政策進行變更、移除或新增。
        <br />
        <br />
        ⑤ 使用者可隨時透過設定畫面變更，以關閉更新通知功能。在此情況下，公司將不會向使用者發送更新通知。
        <br />
        <br />
        ⑥ 公司可直接或透過 BubbleTap 或合作關係的第三方，在服務畫面、官方網站等處刊登廣告。
        <br />
        <br />
        ⑦
        公司僅限於取得會員事前同意的情況下，可透過電子郵件、簡訊、應用程式推播、電子訊息等電子傳輸媒介發送廣告資訊。若會員不希望接收廣告資訊，可隨時拒絕，公司在會員拒絕接收後便不會再發送。
        <br />
        <br />⑧ 會員不應對公司提供的服務相關的貼文或其他資訊採取變更、修改、限制等措施。
      </ol>
      <p>第16條 貼文的著作權</p>
      <ol>
        ①
        會員在服務內發布的貼文，其著作權歸屬於該貼文的創作者。會員同意依據本服務條款，提供公司其貼文及輸入訊息的使用權或授權。此使用權不代表著作權的轉讓。貼文著作權的範圍不包含公司為協助會員創作或生成貼文所提供的技術、工具、軟體、平台設計、輸出訊息等。未經公司明確許可，會員不得複製、修改、散布或使用公司的智慧財產權。
        <br />
        <br />
        ②
        使用者或會員透過在公司的平台上發布貼文，即允許公司對該貼文擁有有限的使用權。使用者或會員因使用公司服務而授予公司的使用權為非獨占性。此使用權可由公司非獨占性地轉讓或授權，並可用於多種商業用途，包括但不限於創作衍生作品、模型研究開發與訓練等。使用者或會員在服務內發布的貼文，可能會被用於公司的行銷、宣傳及促銷活動（包含在必要範圍內的局部修改、複製、編輯），以擴展公司現有及未來的服務、新媒體或語言轉譯等。此外，使用者或會員的貼文也可用於改善公司、內容及服務，以及開發新內容及服務之研究目的。
        <br />
        <br />
        ③ 根據相關國家法令規定，使用者或會員在使用公司的 AI 服務時，擁有由公司的 AI
        服務所生成的內容（包含輸出訊息、文字、圖像、語音、音樂、背景音樂、影片等）之著作權。使用者或會員透過使用公司的服務，即授予公司對該生成內容的非獨占、有限制的使用權。此使用權可由公司非獨占性地轉讓或授權，並可用於多種商業用途，例如創作衍生作品、模型研究開發及訓練等。使用者或會員在使用公司服務時所生成的內容，可能會用於公司的行銷、宣傳及促銷活動（包含在必要範圍內的局部修改、複製、編輯），以擴展公司現有及未來的服務、新媒體或語言轉譯等。此外，使用者或會員所生成的內容，也可用於改善公司、內容及服務，以及開發新內容及服務之研究目的。
        <br />
        <br />④
        即使使用者或會員將自己的貼文從公司的服務中刪除或設為不公開，所授予公司的有限使用權（參照第②項）依然有效。
        <br />
        <br />⑤ 若公司欲透過第②項以外的方式利用會員的貼文，必須事先透過電話、傳真、電子郵件等方式徵得會員同意。
        <br />
        <br />⑥ 會員保證透過使用公司的服務，其對所有貼文及輸入訊息擁有完整的權利、權限、授權或著作權。
      </ol>
      <p>第17條 貼文的管理</p>
      <ol>
        ①
        會員的貼文若包含違反韓國《資訊通信網路利用促進及資訊保護法》等相關法律、《著作權法》等相關法令的內容時，權利人可依據相關法律規定的程序，要求停止發布或刪除該貼文，而公司應當依據相關法律採取措施。
        <br />
        <br />
        ②
        即使沒有權利人依前項規定提出的要求，若有足夠理由認定存在侵權行為，或違反其他公司政策及相關法令時，公司仍可依據相關法律對該貼文採取暫時措施。因此，公司有權審查及刪除會員或使用者的內容或貼文。此外，公司也可根據內部判斷，暫停或刪除該會員或使用者的帳號。
        <br />
        <br />③
        根據本條文的詳細程序，將依據韓國《資訊通信網路利用促進及資訊保護法》等相關法律、《著作權法》所規定的範圍內，遵循公司制定的停止發布要求服務。
      </ol>
      <p>第18條 權利的歸屬</p>
      <ol>
        ① 服務的著作權及智慧財產權歸公司所有。但會員的貼文及依合作契約提供的著作物等不在此限。
        <br />
        <br />②
        公司僅依據其制定的使用條款，賦予會員使用帳號、ID、資訊及支付方式等的權利。除非公司允許，會員不得以轉讓、出售、提供擔保等方式處分這些權利。
      </ol>
      <p>第19條 支付方式與退款</p>
      <ol>
        ①
        會員可透過以下各款方式使用付費服務。但基於服務營運或與內容供應商簽約等原因，公司可能僅就部分內容提供其中部分支付方式。此外，若會員選擇的支付方式有另外的供應商，會員在使用該支付方式前，應完成其要求的程序後方可進行支付，且使用該支付方式進行支付時，應適用會員與該支付方式供應商簽訂的契約條款。
        <li>App Market (Google Play) 應用程式內購買</li>
        <li>App Market (App Store) 應用程式內購買</li>
        <li>Toss Payments 股份有限公司 網路支付</li>
        <li>其他公司規定的支付方式</li>
        <br />② 根據公司的政策及第 1
        項支付方式供應商規定的標準，會員每月的累積支付金額及付費服務購買額度可能會受到限制。若超過該標準，可能無法繼續使用付費服務。會員以信用卡支付公司內部商品時，若信用卡公司將支付金額限制在一定金額以下或無法進行支付，則可能導致支付失敗。
        <br />
        <br />③ 公司的內部商品不可在會員之間轉讓。
        <br />
        <br />④ 公司內部商品的有效期限如下。
        <ol>
          <li>購買的公司內部商品，使用期限最長為 1 年。</li>
          <li>免費提供給會員的公司免費內部商品，使用期限最長為 1 年以內。</li>
        </ol>
        ⑤ 取消支付與退款
        <ol>
          <li>購買公司內部商品後，退款將透過購買內部商品時使用的支付方式進行。</li>
          <li>可要求退款公司內部商品的期限為自購買時起 7天內。</li>
          <li>
            與公司簽訂購買契約的會員，可依據以下規定要求取消支付及退款：
            <ol>
              <li style={{ listStyleType: 'lower-alpha' }}>
                購買公司內部商品後，若已使用該商品組合包中的部分付費或免費內部商品，則無法針對未使用的部分進行取消支付及退款。換言之，購買的公司內部商品組合包無法進行部分退款。
              </li>
              <li style={{ listStyleType: 'lower-alpha' }}>
                購買公司內部商品組合包後，若其中包含的付費及免費內部商品皆未使用，則可依據該組合包購買時的支付金額進行取消及退款。
              </li>
            </ol>
          </li>
          <li>若因公司原因導致支付錯誤，可要求取消支付及退款。請參考本服務條款第23條。</li>
          <li>若因公司原因導致服務中斷，可要求取消支付及退款。請參考本服務條款第14條。</li>
        </ol>
      </ol>
      <p>第20條 會員的申請撤回等、契約終止及會員退出</p>
      <ol>
        ① 會員可隨時透過服務首頁的客服中心或My Page選單等申請終止使用契約或退出會員，公司應依據相關法律等規定立即處理。
        <br />
        <br />
        ②
        若會員終止契約或退出會員，除依據相關法律及個人資訊處理方針規定，公司須保留會員資訊的情況外，會員的所有資訊將於終止契約後立即銷毀。
        <br />
        <br />
        ③
        若會員終止契約或退出會員，會員發布的內容中，註冊於本人帳號內的貼文可能不會被刪除。尤其是會員創建的AI角色、故事情節、故事背景等不會被刪除。已被第三方轉載、收藏等重新發布，或已發布至公共討論區的貼文，將不會被刪除，因此請務必於退出前自行刪除。
        <br />
        <br />④
        簽訂付費服務使用契約或購買公司內部商品的會員，可依據公司內部政策及相關法令規定，在一定期間內撤銷申請或解除契約（以下簡稱「申請撤回等」）。但有下列各款情形者，將限制申請撤回等：
        <ol>
          <li>經公司判斷，會員在付費購買公司內部商品後，有濫用該內部商品退款（參照服務營運政策第6條）之行為。</li>
          <li>會員在付費購買公司內部商品後，已消耗部分付費或免費部分，試圖就剩餘內部商品餘額申請撤回或退款。</li>
          <li>會員試圖就公司提供的免費內部商品申請撤回或退款。</li>
          <li>因可歸責於會員的事由，導致商品等滅失或毀損。但為確認商品等內容而損壞包裝等的情況除外。</li>
          <li>因會員使用或部分消耗，導致商品等價值顯著減少。</li>
          <li>因時間經過，導致商品等價值顯著減少，難以再次銷售。</li>
          <li>
            可複製的商品等，其包裝已毀損的情況，或依據韓國《文化產業振興基本法》第2條第5款，數位內容已開始提供的情況。但由可分割的服務或可分割的數位內容組成的契約，對於尚未開始提供的部分，則不在此限。
          </li>
          <li>
            依會員訂單個別生產的商品等，或與其類似的商品等，若承認申請撤回等，將預期對BubbleTab造成無法彌補的重大損害，且事前已就該交易單獨告知該事實並取得會員書面（含電子文件）同意的情況。
          </li>
        </ol>
        ⑤
        儘管有前項規定，如果公司的付費服務內容與標示、廣告內容不同，或者與合約內容不符，會員可以在收到該商品或服務之日起三個月內，或從得知或可得知該事實之日起三十天內，撤銷或取消訂單。
        <br />
        <br />⑥ 會員在下列任一情況下，可以解除或終止付費服務的使用合約：
        <ol>
          <li>付費服務的瑕疵無法修補或修正，且從收到付費服務之日起一個月內。</li>
          <li>會員不同意本條款的變更，因此選擇退出會員或解除付費服務的使用合約。</li>
        </ol>
        ⑦ 根據第一項和第二項規定，公司與會員之間關於退貨、換貨、退款及取消的相關事項，應依照第 21 條的規定辦理。
      </ol>
      <p>第21條 撤銷申請等及解除契約的效力</p>
      <ol>
        ①
        本公司應在會員提出撤銷申請、解除契約之意思表示日起3個工作日內，將退款決定通知會員。退款決定後，應在3個工作日內以與付款相同的方式退款；若無法以相同方式退款時，應事先告知。但對於需確認收款的支付方式，可在確認收款之日起3個工作日內進行退款。
        <br /> <br />
        ② 會員的撤銷申請及解除契約可能受到服務條款第19條及第20條的限制。
        <br /> <br />
        ③
        本公司退款時，若會員是使用信用卡或電子支付工具等方式支付商品等價金，本公司應立即要求提供該支付工具的業者停止或取消該商品等價金的請款。但第1項但書及第2項的情形可能不在此限。
        <br /> <br />
        ④ 收取本公司付費服務費用者或與會員簽訂付費服務使用契約者若非同一人，雙方應對履行與撤銷申請等相關義務負連帶責任。
        <br /> <br />⑤
        本公司針對應用程式商店內支付（應用程式內購買）及網頁支付，會依據韓國《電子商務消費者保護法》等相關規定，向該應用程式商店及網頁支付業者採取要求停止或取消付款等相關措施。但關於本公司提出上述要求後，該應用程式商店所採取的措施，請參考該應用程式商店的政策。
      </ol>
      <p>第22條 本公司解除、終止契約及使用限制等</p>
      <ol>
        ①
        若會員違反本條款、個別條款等規定，或有合理懷疑或已證實妨礙服務正常運作的行為時，本公司可透過警告、暫時停用、永久停用等方式，逐步限制其服務使用。儘管採取這些限制，若已無法再期待能完整維持服務使用契約，本公司除了採取使用限制措施外，可同時解除或終止與會員的服務使用契約。
        <br /> <br />
        ② 若會員連續超過3個月未登入，本公司為保護會員資訊及提高營運效率，可直接限制其服務使用。
        <br /> <br />
        ③
        關於第1項及第2項，會員透過使用服務獲得的無償優惠將會失效，本公司對此不另行補償。但若因會員的責任導致本公司解除或終止使用契約，本公司會依會員要求退還付費服務的費用；然而，若發生ID被盜用、或ID被用於非法行為（包括但不限於非法複製或散布內容）等特殊情況時，則不予退款或補償。
        <br /> <br />
        ④
        本公司依據第3項但書規定需要退款時，準用第22條第1項，但可從應退還的金額中扣除會員因使用付費服務所獲得的利益，以及相當於退款手續費（10%或1,000韓元中金額較高者）的款項。
        <br /> <br />
        ⑤⑤ 第1項的解除或終止，於本公司依本條款所定之通知方式向會員表示其意願時生效。
        <br /> <br />⑥
        對於本公司的解除、終止及使用限制，會員可依本公司規定之程序提出異議申請。此時，若異議被認定為正當，本公司應立即恢復其服務使用。
      </ol>
      <p>第23條 溢繳款項</p>
      <ol>
        ① 若發生溢繳款項，本公司將以會員支付時的相同方式進行退款；若無法以相同方式退款時，本公司應事先告知。
        <br /> <br />
        ②
        若因本公司的責任導致溢繳款項，本公司將全額退還；若因會員的責任導致溢繳款項，退款所需費用應由會員在合理範圍內承擔。
        <br /> <br />③ 本公司會依照內容服務使用者保護指南處理溢繳款項的退款程序。
      </ol>
      <p>第24條 使用期限等</p>
      付費服務的使用期限或有效期限，若事前沒有另行標示，則為自交易日起算1年。超過該期限的付費服務，其使用權限將會失效，並可能從持有清單中刪除。
      <p>第25條 因商品等瑕疵造成損害之賠償</p>
      因付費服務的瑕疵等導致會員遭受損害的賠償，將依據內容服務使用者保護指南所規定之內容辦理。
      <p>第26條 責任限制</p>
      <ol>
        ① 因天災或與之相當的不可抗力事件導致無法提供服務時，本公司得免除提供服務的責任。
        <br /> <br />
        ② 因會員的歸責事由導致服務使用產生障礙時，本公司不負任何責任。
        <br /> <br />
        ③
        對於會員在服務中發布，以及透過本公司AI服務產生的資訊、資料及結果的可靠性、正確性、合法性、原創性、排他性、真實性、可用性及適合性，本公司不予保證，且不對會員或使用者依據相關內容所採取的行為負責。
        <br /> <br />
        ④ 因使用本公司AI服務的資訊、資料及結果所產生的一切問題，均由會員自行承擔責任，本公司對此不負任何責任。
        <br />
        <br />
        ⑤
        本公司對於會員或使用者在留言板上發布，或使用本公司服務時發布的資訊、資料、內容等的真實性、可靠性等不負任何責任，會員應自行承擔責任使用服務。
        <br />
        <br />
        ⑥
        對於會員因使用服務所遭受的損害中，因會員的故意、過失所造成的損害，以及因其他會員所遭受的精神損害，本公司不負賠償責任。
        <br />
        <br />
        ⑦
        若會員之間或會員與第三者之間，透過本公司的服務進行溝通、聯絡、交流、交易等而產生任何損害或損失，本公司得免除責任。
        <br /> <br />⑧ 除非有相關法律規定，本公司對與服務使用相關的事項不負任何責任。
        <br />
        <br />⑨ 若會員違反本使用條款導致對方遭受損害，應負賠償責任。但若無故意或過失，則不在此限。
        <br />
        <br />⑩ 對於會員發布或傳輸的資料等所產生的損害，或因資料的取捨選擇所產生的任何不利益，所有責任均由會員自行承擔。
        <br />
        <br />⑪ 若本公司或會員違反本條款導致對方遭受損害，應負賠償責任。但若無故意或過失，則不在此限。
      </ol>
      <p>第27條 準據法及裁判管轄</p>
      <ol>
        ① 公司與會員間所提起之訴訟，應以大韓民國法律作為準據法。
        <br /> <br />
        ②
        公司與會員間發生之糾紛訴訟，應依據提起訴訟當時會員之住址管轄，若無住址則由其居所之地方法院專屬管轄。但若提起訴訟當時會員之住址或居所不明確，則管轄法院應依《民事訴訟法》規定決定。
        <br /> <br />③
        會員若於海外設有住址或居所，儘管有前項規定，公司與會員間發生之糾紛訴訟仍應以大韓民國首爾中央地方法院為管轄法院。
      </ol>
      <br />
      ©2025 BubbleTap. All rights reserved.
      {/* <p>[부칙] 이 약관은 2022년 8월 xx일부터 적용됩니다.</p> */}
    </Styled.MainWrapper>
  );
}

export default TermsOfServiceZh;
